<av-content-container [fullHeight]="true">
  <div class="w-100 h-100 py-3 d-flex flex-column justify-content-center">
    <av-empty-state
      icon="search_off"
      titleKey="app.catalog.demandReference.miss.title"
      subtitleKey="app.catalog.demandReference.miss.description"
    >
      <form
        class="demand-reference-miss__form d-flex align-items-center gap-2"
        [formGroup]="lookupForm"
        (ngSubmit)="onSubmitLookup()"
      >
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flex-grow-1">
          <mat-label>{{ 'app.catalog.demandReference.miss.inputLabel' | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="reference"
            autocomplete="off"
            autocapitalize="characters"
            spellcheck="false"
            [placeholder]="'app.catalog.demandReference.miss.inputPlaceholder' | translate"
          />
        </mat-form-field>
        <button mat-flat-button color="primary" type="submit" class="flex-shrink-0">
          {{ 'app.catalog.demandReference.miss.submit' | translate }}
        </button>
      </form>
    </av-empty-state>
  </div>
</av-content-container>
